/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geowindow71Inputs */

const en_geowindow71 = /** @type {(inputs: Geowindow71Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 days`)
};

const de_geowindow71 = /** @type {(inputs: Geowindow71Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 Tage`)
};

/**
* | output |
* | --- |
* | "7 days" |
*
* @param {Geowindow71Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geowindow71 = /** @type {((inputs?: Geowindow71Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geowindow71Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geowindow71(inputs)
	return de_geowindow71(inputs)
});
export { geowindow71 as "geoWindow7" }